module.exports = __webpack_public_path__ + "static/media/7.e0bf18cf.png";